export type ReplyPayload = {
  ticket_id: string;                 
  recipient_email: string;
  agent_name: string;             
  original_subject: string;
  reply_to_message_id: string;     
  references: string[];
  email_body_text: string;
  email_body_html?: string | null;
  attachments: any[];
};

export function wrapMsgId(x?: string | null) {
  if (!x) return null;
  const s = String(x).trim();
  if (!s) return null;
  if (s.startsWith("<") && s.endsWith(">")) return s;
  return `<${s.replace(/^<|>$/g, "")}>`;
}

export function uniq(arr: (string | null | undefined)[]) {
  const set = new Set<string>();
  for (const x of arr) if (x) set.add(x);
  return Array.from(set);
}

export function normalizeReSubject(subject?: string | null) {
  const s = (subject || "").trim();
  if (!s) return "Re: (no subject)";
  if (/^re:\s*/i.test(s)) return s;
  return `Re: ${s}`;
}
